// extracted by mini-css-extract-plugin
export default {"leftCol":"MainPage_leftCol__CDcJg","rightCol":"MainPage_rightCol__hh+qU","middleCol":"MainPage_middleCol__6T5n2"};